import React from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { v2Colors } from '../../design/theme';
import MostLovedProductCard from './MostLovedProductCard';

const DISPLAY_FONT = '"Foregen", "Roboto Slab", Georgia, serif';

export default function MostLovedSection({ products = [] }) {
  const navigate = useNavigate();

  if (!products?.length) return null;

  return (
    <Box sx={{ mb: { xs: 3, md: 4 } }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'baseline',
          justifyContent: 'space-between',
          mb: 1.5,
        }}
      >
        <Typography
          component="h2"
          sx={{
            fontFamily: DISPLAY_FONT,
            fontWeight: 700,
            fontSize: { xs: '1.1rem', md: '1.25rem' },
            color: v2Colors.heading,
            letterSpacing: '-0.02em',
          }}
        >
          Most loved
        </Typography>
        <Typography
          component="button"
          type="button"
          onClick={() => navigate('/v2/catalog')}
          sx={{
            border: 'none',
            margin: 0,
            padding: 0,
            cursor: 'pointer',
            bgcolor: 'transparent',
            fontFamily: 'inherit',
            fontSize: '0.85rem',
            fontWeight: 600,
            color: v2Colors.primary,
          }}
        >
          See all →
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          gap: 1.5,
          overflowX: 'auto',
          pb: 0.5,
          mx: { xs: -2, md: 0 },
          px: { xs: 2, md: 0 },
          scrollSnapType: 'x mandatory',
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': { display: 'none' },
        }}
      >
        {products.map((p) => (
          <Box key={p.id || p.documentId || p.name} sx={{ scrollSnapAlign: 'start' }}>
            <MostLovedProductCard product={p} />
          </Box>
        ))}
      </Box>
    </Box>
  );
}
